import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, c = /* @__PURE__ */ o("path", { d: "m41.418 13.248-1.353-1.356a.955.955 0 0 0-.3-.21.975.975 0 0 0-.737 0 .946.946 0 0 0-.31.21l-19.06 19.053-10.42-10.416a.944.944 0 0 0-.3-.207.963.963 0 0 0-.366-.075.976.976 0 0 0-.37.075.944.944 0 0 0-.3.207L6.55 21.888a.96.96 0 0 0 0 1.353l13.134 13.137 21.77-21.774a.963.963 0 0 0 0-1.356h-.035Z" }, null, -1), r = [
  c
];
function s(a, l) {
  return e(), t("svg", n, r);
}
const _ = { render: s };
export {
  _ as default,
  s as render
};
//# sourceMappingURL=check.svg.mjs.map
